// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// 注冊全局组件标签
import ElementUI from 'element-ui'
/* 静态预编译主题颜色，编译后引入css文件，速度快*/
import '@/assets/theme/index.css'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import App from './App'
import router from './router'
import store from '../../store/index'

import '@/icons' // icon
import FastClick from 'fastclick'
import '../../filters/index'
import './permission'
import '@/common/styles/index.scss'
import '@/common/styles/animate.css'

Vue.use(ElementUI)
FastClick.attach(document.body)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/modules/pc/pc.js